import Snackbar from "@mui/material/Snackbar";
import React, { useEffect, useState } from "react";

export const Toast = ({ error }: { error: string }) => {
  const [open, setOpen] = useState(true);
  useEffect(() => {
    setTimeout(() => setOpen(false), 5000);
  }, []);

  return <Snackbar sx={{ maxWidth: "80vw" }} open={open} message={error} />;
};
